import { cn, Toggle } from "@monbits/ui";
import type * as React from "react";
import { CryptoIcon } from "src/components/crypto-icon/crypto-icon";
import type { BlockchainTicker, PaymentMethod } from "src/types/index";

interface Props {
	title: string;
	items: PaymentMethod[];
	onChange: (ticker: BlockchainTicker) => void;
	isLoading: boolean;
}

const PaymentMethodsItem: React.FC<Props> = (props: Props) => {
	return (
		<div className="flex flex-wrap gap-2">
			{props.items.map((item) => (
				<div key={item.name} className="relative">
					<Toggle
						pressed={item.enabled}
						onPressedChange={() => props.onChange(item.ticker)}
						className={cn(
							"flex items-center gap-2 px-4 py-2 h-auto",
							"data-[state=on]:bg-primary data-[state=on]:text-primary-foreground",
							"data-[state=off]:bg-muted data-[state=off]:text-muted-foreground",
						)}
					>
						<CryptoIcon
							ticker={item.ticker}
							className="h-4 w-4"
							showComposite={true}
						/>
						<span className="text-xs font-medium">{item.name}</span>
					</Toggle>
				</div>
			))}
		</div>
	);
};

export default PaymentMethodsItem;
